import React, { ReactElement } from "react"
import moment from "moment"
import StyledDatePicker from "./StyledDatePicker"
import { DataVisualizationGranularity } from "types/data-visualization.types"

interface PeriodValue {
  startDate: Date
  endDate: Date
}

interface PeriodInputProps {
  value?: PeriodValue
  onChange: (value: PeriodValue) => void
  placeholder?: string
  label?: string
  required?: boolean
  width?: string
  height?: string
  disabled?: boolean
  updateGranularity: (granularity: DataVisualizationGranularity) => void
}

export default function PeriodInput({
  value,
  onChange,
  placeholder,
  label,
  required = false,
  width,
  height,
  disabled = false,
  updateGranularity,
}: PeriodInputProps): ReactElement {
  // Set default period to last 30 days if no value provided
  const defaultValue: PeriodValue = value || {
    startDate: moment.utc().subtract(30, "days").toDate(),
    endDate: moment.utc().toDate(),
  }

  const handleChange = (dateRange: PeriodValue): void => {
    onChange(dateRange)
  }

  return (
    <StyledDatePicker
      value={defaultValue}
      onChange={handleChange}
      placeholder={placeholder}
      label={label}
      required={required}
      width={width}
      height={height}
      disabled={disabled}
      updateGranularity={updateGranularity}
    />
  )
}
